import { Box } from "arkh";
import React, { useCallback, useMemo } from "react";
import { useIntlTokens } from "../../../../../../components/mobile/useIntlTokens";
import { getWidgetAddWidgetSizeWithinBounds } from "../../utils/useWidgetAddWidgetSizeState";
import { WACategoryScreenProps } from "../../WANavigation";
import { WACategoryWidgetContainer } from "../../WACategoryWidgetContainer";
import { overviewWidgetSizes } from "../../utils/widgetSizes/overviewWidgetSizes";
import { useWidgetTeamScheduleMockPreviewQueryLoader } from "./useWidgetTeamScheduleMockPreviewQueryLoader";
import { WidgetTeamScheduleMockPreview } from "./WidgetTeamScheduleMockPreview";
import { FormattedMessage } from "react-intl";
import { ScrollView } from "react-native";
import { useWACategoryLayout } from "../../utils/useWACategoryLayout";

type Props = WACategoryScreenProps<"WACategoryTeamSchedule">;

export function WACategoryTeamSchedule(props: Props) {
  const intl_tokens = useIntlTokens();

  const [teamScheduleSize, hasSizeWithinBounds] = useMemo(
    () =>
      getWidgetAddWidgetSizeWithinBounds({
        widgetSizes: overviewWidgetSizes,
        maxSize: props.route.params.maxSize,
      }),
    [props.route.params.maxSize]
  );

  const onAdd = useCallback(() => {
    props.navigation.navigate("WidgetAddTeamSchedule", props.route.params);
  }, [props.navigation, props.route.params]);

  const queryRef = useWidgetTeamScheduleMockPreviewQueryLoader({
    storecastId: props.route.params.storecastId,
    size:
      teamScheduleSize.h === 1
        ? "TWO_X_ONE"
        : teamScheduleSize.h === 2
          ? "TWO_X_TWO"
          : teamScheduleSize.h === 3
            ? "TWO_X_THREE"
            : "TWO_X_FOUR",
  });

  const contentContainerStyle = useWACategoryLayout();

  return (
    <ScrollView contentContainerStyle={contentContainerStyle}>
      <Box
        style={{
          flex: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <WACategoryWidgetContainer
          hasSizeWithinBounds={hasSizeWithinBounds}
          size={teamScheduleSize}
          title={intl_tokens.TeamSchedule}
          unitSize={props.route.params.unitSize}
          onAdd={onAdd}
          addTitle={intl_tokens.SelectTeam}
          description={
            <FormattedMessage
              defaultMessage="Show live updated team schedule"
              description="WATeamSchedule description"
            />
          }
        >
          {queryRef ? (
            <WidgetTeamScheduleMockPreview queryRef={queryRef} />
          ) : null}
        </WACategoryWidgetContainer>
      </Box>
    </ScrollView>
  );
}
